export default __webpack_public_path__ + "static/media/swan.261ff3d4.jpeg";